import React from "react";
import Floaticons from "../Floaticons";
import "./APIautomationContent.css";
import APIautomationLearningCards from "./APIautomationLearningCards";
import APIautomationLearningJourney from "./APIautomationLearningJourney";
import "./SREContent.css";
import mailData from ".././../data/mailData";

function APIautomationContent() {
  return (
    <>
      <div id="APIAutomation">
        <div className="main-banner">
          <h1 className="sr-only">API Atomation Testing</h1>
          <img
            src="images/APIautomation/Automation-banner.png"
            alt="Banner"
            className="banner-img"
          />
          <img
            src="images/Home/banner-strip.png"
            alt="strip"
            className="strip-img"
          />
          <div className="announcemnt-box">
            <p>
              <img
                src="images/Home/speaker.png"
                alt="speaker"
                className="speaker-img"
              />
              <marquee
                width="92%"
                direction="left"
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                {" "}
                <b>Come Join Us</b> on an exhilarating learning Journey on
                Enbridge Talent Academy Platform!!!
              </marquee>
            </p>
          </div>
          <Floaticons />
        </div>
        <div className="main-container">
          {/* section 1  */}
          <div className="about-container">
            <div className="about-wrap">
              <h2>About API Automation</h2>
              <h3>
                API Testing :
                <span>
                  API Testing is a specialized study in quality engineering that
                  validates Application Programming Interface (APIs) to check
                  its functionality, performance, reliability etc., It mainly
                  concentrates on the business logic layer of any software
                  architecture.
                </span>
              </h3>
              <h3>
                PostMan :
                <span>
                  PostMan is a standalone API to test APIs. It uses a simple GUI
                  for sending and viewing HTTP requests and responses. Selenium
                  is an open-source test automation framework used to automate
                  web applications.{" "}
                </span>
              </h3>
              <h3>
                Rest Assured :
                <span>
                  Rest Assured is a java-based library that is used to test
                  restful web services. Rest-Assured library also provides the
                  ability to validate the HTTP Responses received from the
                  server.
                </span>
              </h3>
            </div>
          </div>
          {/* section 2  */}
          <div id="SRE-Objective">
            <div className="program-container">
              <div className="program-wrap">
                <h2>Program Objectives</h2>
                <ul id="double">
                  <li>Understand the overview of API </li>
                  <li>Types of API and HTTP methods</li>
                  <li>API Testing tools</li>
                  <li>Working with request and response headers</li>
                  <li>Authentications in API </li>
                  <li>API Testing and its benefits</li>
                  <li>API Testing Vs Unit Testing</li>
                  <li>How to do API Testing using PostMan</li>
                  <li>Collections </li>
                  <li>Creating Variables</li>
                  <li>Writing API Test cases using PostMan</li>
                  <li>Scripting in PostMan</li>
                  <li>Understand RestAssured API</li>
                  <li>Data Extraction techniques</li>
                  <li>Assertion Techniques</li>
                </ul>
              </div>
            </div>
          </div>
          <APIautomationLearningJourney />
          <div className="casestudyNote">
            <p>
              <strong>Note: </strong>For Case Study details, please contact{" "}
              <a href={`mailto:${mailData.enbridge_talentAcademy_mail}`}>
                {mailData.enbridge_talentAcademy_mail}
              </a>
            </p>{" "}
          </div>
          {/* <div className='external-certification-container'>
                    <h5>External Certifications</h5>
                    <p>Complete your learning journey and earn accredited external certification in the area of your expertise which can help in advancing your career.</p>
                    <div className="ex-wrapper">
                        <div>
                            <img src='images/Home/Journey-icon.png' alt='certification-icon' />
                            <span>Lorem ipsum dolor sit amet.</span>
                        </div>
                        <div>
                            <img src='images/Home/Journey-icon.png' alt='certification-icon' />
                            <span>Lorem ipsum dolor sit amet.</span>
                        </div>
                    </div>
                </div> */}
          <APIautomationLearningCards />
          {/* section 3  */}
          <div className="features-container SRE">
            <h5>Program Highlights</h5>
            <div className="features-wrap">
              <div className="features-row">
                <img
                  src="images/SRE/feature-icon1.png"
                  alt="Self-paced Learning-icon"
                  className="feature-icon"
                />
                <p>Self-paced Learning</p>
              </div>
              <div className="features-row">
                <img
                  src="images/SRE/feature-icon2.png"
                  alt="SME Connects-icon"
                  className="feature-icon"
                />
                <p>SME Connects</p>
              </div>
              <div className="features-row">
                <img
                  src="images/SRE/feature-icon3.png"
                  alt="Final Assessment-icon"
                  className="feature-icon"
                />
                <p>Final Assessment</p>
              </div>
              <div className="features-row">
                <img
                  src="images/SRE/feature-icon4.png"
                  alt="Completion Certificates-icon"
                  className="feature-icon"
                />
                <p>Earn Completion Certificates, Flair, R&R</p>
              </div>
              <div className="features-row">
                <img
                  src="images/SRE/feature-icon6.png"
                  alt="Case Studies-icon"
                  className="feature-icon"
                />
                <p>End-to-End case studies</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default APIautomationContent;
